import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
var SettingsPage = lazy(function () { return import('@/modules/mobility-console/pages/settings'); });
var DashboardPage = lazy(function () { return import('@/modules/mobility-console/pages/dashboard'); });
export var MobilityConsoleRoutes = [
    {
        path: '/',
        element: _jsx(DashboardPage, {}),
    },
    {
        path: '/settings',
        element: _jsx(SettingsPage, {}),
    },
];
